import React, { useEffect, useState } from "react";
import plusIcon from "../../../../../Assets/Images/Svg/plusIcon.svg";
import AddMedication from "./AddMedication";
import { Modal } from "antd";
import moment from "moment";
import MedicalHistoryService from "../../../../../Services/MedicalHistoryService";
import { useSelector } from "react-redux";
import { FiPlus } from "react-icons/fi";
import dayjs from "dayjs";

function Medication({ permissionData }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [medicationData, setMedication] = useState([]);
  const { selectedRpmPatient } = useSelector((state) => state.rpm);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    medication();
  }, [permissionData]);

  const handleLatestUpdate = (data) => {
    setMedication(data);
  };

  const medication = () => {
    const patientRaw = sessionStorage.getItem("patient");
    let patientData = patientRaw ? JSON.parse(patientRaw) : null;

    const userObj = sessionStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;

    const patientCode = patientData?.patientId || selectedRpmPatient?.patientId;

    if (permissionData) {
      let payload = {
        // account_Id: userData?.user?.account_Id,
        // clinic_Id: userData?.user?.clinic_Id,
        userId:
          permissionData === null || permissionData?.medicalHistory === "N"
            ? userData?.user?.userId
            : "",
        patientCode,
        status: 1,
      };
      MedicalHistoryService.PatientMedication(payload).then((result) => {
        setMedication(result.data);
      });
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  return (
    <>
      {/* <div className="card h-[300px] m-5 border rounded-lg">
        <div className="header h-[20%] bg-brand-primaryColor flex items-center justify-between  rounded-lg p-2">
          <h1 className="font-bold text-white text-normal ">Medication</h1>
          <img
            src={plusIcon}
            onClick={showModal}
            className="h-10 w-10 cursor-pointer"
            alt=""
          />
        </div>
        <div className="body h-[70%] overflow-y-auto bg-[#DEF3F2] custom-scrollbar  p-2">
          {medicationData.length > 0
            ? medicationData.map((user, i) => (
                <div>
                  <div key={i} className="items-center mt-3 text-sm">
                    <p>Drug Name : {user.drugName}</p>
                    <p>Composition : {user.composition} </p>
                    <p>Dosage : {user.dosage} </p>
                    <p>Frequency : {user.frequency} </p>
                    <p>
                      Duration : {user.duration} {user.durationType}{" "}
                    </p>
                    <p>Indication : {user.indication} </p>
                    <p>Side Effects : {user.sideEffects} </p>
                    <p>Compliance : {user.compliance} </p>
                    <p>Adverse Effects : {user.adverseEffects} </p>
                    <p>
                      Advice related to medicines : {user.adviceRelatedMedicine}{" "}
                    </p>
                    <p className="text-gray-500">
                      check up date : {user.givenDate?.slice(0, 11)}
                    </p>
                  </div>
                  <hr className="my-4 border-gray-300" />
                </div>
              ))
            : null}
        </div>
        <div className="footer h-[10%] bg-brand-primaryColor rounded-md"></div>
      </div> */}
      <div
        className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
        id="unquie-scroll"
      >
        <div className="flex justify-between items-center p-3">
          <h3 className="text-sm font-bold text-gray-700">Medication</h3>
          <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
            <div
              onClick={showModal}
              className="w-6 h-6 rounded-full flex items-center justify-center  bg-brand-primaryColor"
            >
              <FiPlus className="text-white w-4 h-4" />
            </div>
            {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
          </div>
        </div>
        <hr />
        <div className="h-52 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
          {medicationData.length > 0 ? (
            medicationData.map((user, i) => (
              <div
                className="relative"
                onMouseEnter={() => setHoveredIndex(i)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                  <div className="bg-[#FFF8FB] border border-[#FFA2CB] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                    <p>
                      <strong>Drug Name:</strong> {user.drugName}
                    </p>
                    <p>
                      Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                </div>
                {hoveredIndex === i && (
                  <div
                    className="fixed bg-[#585858] text-white text-xs rounded-lg shadow-lg p-3 z-50"
                    style={{ top: "200px", left: "400px" }}
                  >
                    {" "}
                    {user.drugName && (
                      <p>
                        <strong>Drug Name:</strong> {user.drugName}
                      </p>
                    )}
                    {user.composition && (
                      <p>
                        <strong>Composition:</strong> {user.composition}
                      </p>
                    )}
                    {user.dosage && (
                      <p>
                        <strong>Dosage:</strong> {user.dosage}
                      </p>
                    )}
                    {user.frequency && (
                      <p>
                        <strong>Frequency:</strong> {user.frequency}
                      </p>
                    )}
                    {user.duration && (
                      <p>
                        <strong>Duration:</strong> {user.duration}
                      </p>
                    )}
                    {user.indication && (
                      <p>
                        <strong>Indication:</strong> {user.indication}
                      </p>
                    )}
                    {user.sideEffects && (
                      <p>
                        <strong>Side Effects:</strong> {user.sideEffects}
                      </p>
                    )}
                    {user.compliance && (
                      <p>
                        <strong>Compliance:</strong> {user.compliance}
                      </p>
                    )}
                    {user.adverseEffects && (
                      <p>
                        <strong>Adverse Effects:</strong> {user.adverseEffects}
                      </p>
                    )}
                    {user.adviceRelatedMedicine && (
                      <p>
                        <strong> Advice related to medicine:</strong>{" "}
                        {user.adviceRelatedMedicine}
                      </p>
                    )}
                    <p>
                      <strong>Onset date:</strong>{" "}
                      {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div></div>
          )}
        </div>
      </div>
      {isModalOpen && (
        <Modal
          title="Add Medication Details"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
        >
          <AddMedication
            onClose={handleCancel}
            handleLatestUpdate={handleLatestUpdate}
            permissionData={permissionData}
          />
        </Modal>
      )}
    </>
  );
}

export default Medication;
